import type { VisibilityValues } from "@slfinrtl/ui-bff-routes"
import type { RadioGroupFieldProps } from "src/components/form/radio/radioGroup/RadioGroupField"

export interface VisibilityFields {
	marketToCustomers: RadioGroupFieldProps
	onlineOrdering?: RadioGroupFieldProps
}

type FieldName = keyof VisibilityValues

const marketToCustomersName: FieldName = "marketToCustomers"
const onlineOrderingName: FieldName = "onlineOrdering"

export const visibilityFieldNames = {
	marketToCustomersName,
	onlineOrderingName,
}
